var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen }
    },
    [
      [
        _c(
          "ul",
          {
            directives: [{ name: "menu", rawName: "v-menu" }],
            staticClass: "mainmenu w-100 p-0 m-0 menu-active",
            attrs: { id: "menu-1" }
          },
          [
            _vm.dataContainer1.parent
              ? _c(
                  "li",
                  {
                    staticClass: "ddown",
                    on: {
                      click: function($event) {
                        return _vm.slideTo(
                          (_vm.dataContainer1.parent &&
                            _vm.dataContainer1.parent.parent) ||
                            null,
                          true
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "nav-direction d-flex align-items-center mHeader"
                      },
                      [
                        _vm.selectedCat
                          ? [
                              _c("i", {
                                staticClass: "fa fa-long-arrow-left",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex-fill text-center" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.selectedCat.details[0].name) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.dataContainer1.categories, function(category) {
              return _c("li", { staticClass: "ddown" }, [
                _c("a", { attrs: { href: _vm.getCategoryUrl(category.url) } }, [
                  _vm._v(_vm._s(category.details[0].name))
                ]),
                _vm._v(" "),
                category.childCount
                  ? _c(
                      "span",
                      {
                        staticClass: "nav-direction",
                        on: {
                          click: function($event) {
                            return _vm.slideTo(category)
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-right",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            }),
            _vm._v(" "),
            _vm.dataContainer1.categories[0]
              ? _vm._l(
                  _vm.dataContainer1.categories[0].siblingCount -
                    _vm.dataContainer1.categories.length,
                  function(number) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  }
                )
              : _vm.dataContainer1.parent
              ? _vm._l(_vm.dataContainer1.parent.childCount, function(number) {
                  return _c("li", { staticClass: "ddown" }, [
                    _c("span", {
                      staticClass: "nav-placeholder m-3",
                      style: { width: Math.random() * 20 + 60 + "%" }
                    })
                  ])
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.breadcrumbs.length == 0 && _vm.langs.length > 1
              ? [
                  _c("li", [
                    _c(
                      "span",
                      {
                        staticClass:
                          "nav-direction d-flex align-items-center mHeader"
                      },
                      [
                        _c("div", { staticClass: "flex-fill text-center" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$translate(
                                  "Klettershop5::Template.headerLangs"
                                )
                              ) +
                              "\n                        "
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.langs.length > 1
                    ? _c("li", { staticClass: "ddown" }, [
                        _c("a", { attrs: { href: _vm.urlDE } }, [
                          _c("img", {
                            attrs: {
                              src:
                                "https://cdn02.plentymarkets.com/5rubvkuloybx/frontend/Template/Images/Global/flags/mini/de.png"
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate("Klettershop5::Template.german")
                              ) +
                              "\n                    "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.langs.indexOf("en") > -1
                    ? _c("li", { staticClass: "ddown" }, [
                        _c("a", { attrs: { href: _vm.urlEN } }, [
                          _c("img", {
                            attrs: {
                              src:
                                "https://cdn02.plentymarkets.com/5rubvkuloybx/frontend/Template/Images/Global/flags/mini/gb.png"
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate(
                                  "Klettershop5::Template.englisch"
                                )
                              ) +
                              "\n                    "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.langs.indexOf("it") > -1
                    ? _c("li", { staticClass: "ddown" }, [
                        _c("a", { attrs: { href: _vm.urlIT } }, [
                          _c("img", {
                            attrs: {
                              src:
                                "https://cdn02.plentymarkets.com/5rubvkuloybx/frontend/Template/Images/Global/flags/mini/it.png"
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate("Klettershop5::Template.italian")
                              ) +
                              "\n                    "
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            directives: [{ name: "menu", rawName: "v-menu" }],
            staticClass: "mainmenu w-100 p-0 m-0",
            attrs: { id: "menu-2" }
          },
          [
            _vm.dataContainer2.parent
              ? _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        return _vm.slideTo(
                          (_vm.dataContainer2.parent &&
                            _vm.dataContainer2.parent.parent) ||
                            null,
                          true
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "nav-direction d-flex align-items-center mHeader"
                      },
                      [
                        _vm.selectedCat
                          ? [
                              _c("i", {
                                staticClass: "fa fa-long-arrow-left",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex-fill text-center" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.selectedCat.details[0].name) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.dataContainer2.categories, function(category) {
              return _c("li", { staticClass: "ddown" }, [
                _c("a", { attrs: { href: _vm.getCategoryUrl(category.url) } }, [
                  _vm._v(_vm._s(category.details[0].name))
                ]),
                _vm._v(" "),
                category.childCount
                  ? _c(
                      "span",
                      {
                        staticClass: "nav-direction",
                        on: {
                          click: function($event) {
                            return _vm.slideTo(category)
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-lg fa-angle-right",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            }),
            _vm._v(" "),
            _vm.dataContainer2.categories[0]
              ? _vm._l(
                  _vm.dataContainer2.categories[0].siblingCount -
                    _vm.dataContainer2.categories.length,
                  function(number) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  }
                )
              : _vm.dataContainer2.parent
              ? _vm._l(_vm.dataContainer2.parent.childCount, function(number) {
                  return _c("li", { staticClass: "ddown" }, [
                    _c("span", {
                      staticClass: "nav-placeholder m-3",
                      style: { width: Math.random() * 20 + 60 + "%" }
                    })
                  ])
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.breadcrumbs.length == 0 && _vm.langs.length > 1
              ? [
                  _c("li", [
                    _c(
                      "span",
                      {
                        staticClass:
                          "nav-direction d-flex align-items-center mHeader"
                      },
                      [
                        _c("div", { staticClass: "flex-fill text-center" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$translate(
                                  "Klettershop5::Template.headerLangs"
                                )
                              ) +
                              "\n                        "
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.langs.length > 1
                    ? _c("li", { staticClass: "ddown" }, [
                        _c("a", { attrs: { href: _vm.urlDE } }, [
                          _c("img", {
                            attrs: {
                              src:
                                "https://cdn02.plentymarkets.com/5rubvkuloybx/frontend/Template/Images/Global/flags/DE.png"
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate("Klettershop5::Template.german")
                              ) +
                              "\n                    "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.langs.indexOf("en") > -1
                    ? _c("li", { staticClass: "ddown" }, [
                        _c("a", { attrs: { href: _vm.urlEN } }, [
                          _c("img", {
                            attrs: {
                              src:
                                "https://cdn02.plentymarkets.com/5rubvkuloybx/frontend/Template/Images/Global/flags/GB.png"
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate(
                                  "Klettershop5::Template.englisch"
                                )
                              ) +
                              "\n                    "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.langs.indexOf("it") > -1
                    ? _c("li", { staticClass: "ddown" }, [
                        _c("a", { attrs: { href: _vm.urlIT } }, [
                          _c("img", {
                            attrs: {
                              src:
                                "https://cdn02.plentymarkets.com/5rubvkuloybx/frontend/Template/Images/Global/flags/mini/it.png"
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate("Klettershop5::Template.italian")
                              ) +
                              "\n                    "
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              : _vm._e()
          ],
          2
        )
      ],
      _vm._v(" "),
      !_vm.isNavigationInitialized ? [_c("loading-animation")] : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }